import { WithStyles, withStyles, Button, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { userStyles } from "../styles";
import RequestCard from "../components/RequestCard";
import MyPATNoDataPanel from "../../common/MyPATNoDataPanel";
import { MyPATMultiSearch, MyPATSearchBar, MyPATDialog } from "../../common";
import CR_Pagination from "../components/CR_Pagination";
import  { contentRequestActions }  from "../reducers/contentRequestReducer.js";
import { contentRequestData } from "../services/mockData";
import { Tabs } from "../types/Constants";
import _ from 'lodash';
import {
  getSentContentRequest,
  getReceivedContentRequest,
  setSearchText,
  deleteContentRequest
} from '../actions/contentRequestActions'
import dateService from '../../common/services/dateService';
import { axiosNTL } from "../../../services/axios";
import { isLoggedInUserCenterHead, 
         isLoggedInUserMultiCenterHead,
         } from "../helpers/createContentRequest";
import { title } from "process";
import CreateContentRequestPopup from "../components/CreateContentRequestPopup";
import { ContentRequest } from "../types/ContentRequest";

interface ListingContainerProps extends WithStyles<typeof userStyles> {
  setSentContentRequestsData: Function,
  setReceivedContentRequestsData: Function,
  setSearchBar: Function,
  searchBar: any,
  activeTab: any,
  sentContentRequestsData: any,
  receivedContentRequestsData: any,
  getSentContentRequest: Function,
  getReceivedContentRequest: Function,
  setSearchText: Function,
  deleteContentRequest: Function,
  suggestions: any,
  setSuggestions: Function,
  resetFilters: Function
}
interface ListingContainerState {
 searchText: string;
  openRequestPop:boolean;
 
}

class ListingContainer extends Component<
  ListingContainerProps,
  ListingContainerState
> {
  constructor(props: ListingContainerProps) {
    super(props);
    this.state = {
    
      searchText:'',
      openRequestPop:false,
     
    };
  }

  componentDidMount(){
    if(this.props.activeTab === Tabs.SentRequest){
      this.props.getSentContentRequest();
    } else {
      this.props.getReceivedContentRequest();
    }
     this.props.resetFilters();
  }
componentDidUpdate(prevProps:ListingContainerProps){
  if(prevProps.activeTab !== this.props.activeTab){
    this.props.resetFilters();
    if(this.props.activeTab === Tabs.SentRequest){
      this.props.getSentContentRequest();
    } else {
      this.props.getReceivedContentRequest();
    }
    this.setState({
      searchText:''
    })
  }

 

}
  renderContentRequestCards(){
    if (this.props.activeTab === Tabs.SentRequest) {
      let contentRequestCards:any = [];
      if(this.props.sentContentRequestsData){
        return this.renderCards(this.props.sentContentRequestsData);
      }
      return contentRequestCards;
    } else {
      let contentRequestCards:any = [];
      if(this.props.receivedContentRequestsData){
        return this.renderCards(this.props.receivedContentRequestsData);
      }
      return contentRequestCards;
    }
  }

  renderCards(cardsData: any){
    // array obj, key -> date and key -> cards 
    const cardsByDateArray:any = [];
    const currentDates:any = []
    cardsData.map((card: any, index: number) => {
      const currentDate = dateService.dateFromString(card.createdAt);
      if(!currentDates.includes(currentDate)) {
        currentDates.push(currentDate);
        cardsByDateArray.push({
          date: currentDate,
          cards: []
        })
      }
    })
    let updatedCardsByDateArray:any = [];
    cardsData.map((card: any, index: number) => {
        const dateUnderCheck = dateService.dateFromString(card.createdAt);
        updatedCardsByDateArray = cardsByDateArray.map((cardObject: any) => {
            if(cardObject.date === dateUnderCheck){
              cardObject.cards.push(card);
            }
            return cardObject;
        })
    })
    let cards:any = []
    updatedCardsByDateArray.map((cardsByDate:any) => {
      const currentCards = cardsByDate.cards.map((card:any, key: number) => {
        return <RequestCard showDate={key===0 ? true : false} key={_.get(card,'_id', '')} data={card} requestType={
          this.props.activeTab  === Tabs.ReceivedRequest 
          ? "received" 
          : "sent"}/>
      })
      cards.push(currentCards);
    })
   let allCards:any = [];
    cards.forEach((cardsByDate:any) => {
      allCards.push(...cardsByDate)
    })
    return allCards;
  }

  handleEnterSearch = (e: any) => {
    if (e.key === 'Enter') {
      this.handleSearchSelection(e);
    }

	}


  handleSearchSelection = (event: any) => {
    const lowercasedFilter = event.target.value.toLowerCase();
    if(lowercasedFilter && lowercasedFilter.length > 2){
      this.props.setSearchText({
        activeTab: this.props.activeTab,
        searchText: lowercasedFilter
      })
    } else if(this.state.searchText === ''){
      this.props.setSearchText({
        activeTab: this.props.activeTab,
        searchText: ''
      })
    }

    
  }

  // TO BE REMOVED
  // getSearchResult = async (searchQuery: string) => {
  //   let data:any = [];
  //   if(searchQuery && searchQuery.length < 3) {
  //     if(this.props.activeTab === Tabs.SentRequest){
  //       this.props.getSentContentRequest();
  //     } else {
  //       this.props.getReceivedContentRequest();
  //     }
  //   }
  //   if(searchQuery && (searchQuery.length >= 3) ){
  //     data = await this.getContentRequestCardsBySearchQuery(
  //       {
  //         searchQuery,
  //         activeTab: this.props.activeTab
  //       }
  //     )
     
  //     if(searchQuery.includes('-')){

  //       if(data.length > 0) {
  //         if(this.props.activeTab === Tabs.SentRequest){
  //           this.props.setSentContentRequestsData(data)
  //         } else {
  //           this.props.setReceivedContentRequestsData(data)
  //         }
  //         const suggestions = data.map((item:any) => {
  //           return {
  //             'id': item._id,
  //             'label': item.requestId
  //           }
  //         }); // { id: '', label: ''}
      
  //          this.props.setSuggestions(suggestions);
  //         // dispatch action to set sent or received data after handling select
  //       } else {
  //         this.props.setSuggestions(['No Data'])
  //       }

  //     } else {


  //       if(data.length > 0) {
  //         if(this.props.activeTab === Tabs.SentRequest){
  //           this.props.setSentContentRequestsData(data)
  //         } else {
  //           this.props.setReceivedContentRequestsData(data)
  //         }
  //         const suggestions = data.map((item:any) => {
  //           return {
  //             'id': item._id,
  //             'label': item.title
  //           }
  //         }); // { id: '', label: ''}
  //         this.props.setSuggestions(suggestions);
  //       } else {
  //         this.props.setSuggestions(['No Data'])
  //       }


  //     }

      
  //   }

  //   //dispatch action to update sent or received cards data
  // }

  // TO BE REMOVED
  // getContentRequestCardsBySearchQuery = async ({searchQuery, activeTab}:any) => {
  //   try {
  //     const isMultiCenterHead = isLoggedInUserMultiCenterHead();
  //     const isCenterHead = isLoggedInUserCenterHead();
  //     const isAuthor = (!isLoggedInUserMultiCenterHead() && !isLoggedInUserCenterHead());
  //     let URL='';
  //     if(isMultiCenterHead){
  //       URL = '/content-request/multi-centre-head'
  //     }
  //     if(isCenterHead){
  //       URL = '/content-request/centre-head'
  //     }
  //     if(isAuthor){
  //       URL = '/content-request/creator'
  //     }

  //     // const status = select(
  //     //   (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
  //     // )

  //     return await axiosNTL
  //     .get(URL, {
  //       params:{
  //         searchQuery: searchQuery,
  //         type: activeTab
  //       }
  //     })
  //     .then((res:any) => {
  //       return res.responseObject.contentRequests
  //     })
  //     } catch (e) {
  //     console.log('getContentRequestCardsBySearchQuery' + e)
  //   }
  //   return []
  // }
  handleClosePopup = ()=>{
    this.setState({
      openRequestPop:false
    })
  }
  handleTopNav=()=>{
    
    this.setState({
      openRequestPop:true
    })
  }
  toShowNoDataPanel=()=>{
    const noDataInRecievedRequest = _.isEmpty(this.props.receivedContentRequestsData);
    const noDataInSentRequest = _.isEmpty(this.props.sentContentRequestsData);
    const isSentRequestTab =  this.props.activeTab === Tabs.SentRequest;
   let toShowNoDataPanel = false;
    if(isSentRequestTab && noDataInSentRequest){
      toShowNoDataPanel = true;
      
        }
        if(!isSentRequestTab && noDataInRecievedRequest){
          toShowNoDataPanel = true;
        }
      return toShowNoDataPanel;
  }
  render() {
     const { classes } = this.props;
    const { openRequestPop } = this.state;
   const isSentRequestTab =  this.props.activeTab === Tabs.SentRequest;
  let showNoDataPanel = this.toShowNoDataPanel();
 
    return (
      <>
      <div>
        <Grid className={classes.noDataContainer}>
        {
              openRequestPop && 
              <CreateContentRequestPopup 
              createRequestOpen={openRequestPop}
              onClose={this.handleClosePopup}
              />
            }
          <>
              <Grid
                container
                className={classes.filterContainer}
                justify="space-between"
                alignItems="center"
              >
                <Grid item className={classes.searchNew}>
                  {/* <MyPATMultiSearch 
                      options={[]}
                      labelKey="label"
                      valueKey="id"
                      onChange={this.handleSearchSelection} // Setting the selected option
                      values={this.state.searchText}
                      isSearchAble
                      isCustomFilter
                      filtredFunction={this.getSearchResult} // calling API
                      name="creator"
                      noDropDownOptions={true}
                      isDropdownSearch={false}
                  /> */}
                    <Grid className={classes.searchContainer}>
                    <img src="/assets/svg/contentRequest/search-icon.svg" />
                    <input type="text"
                    value={this.state.searchText}
                      onClick={(event: any) => { event.stopPropagation() }}
                      onChange={(event:any) => {
                        this.setState({ searchText:event.target.value })
                        if(event.target.value === ''){ this.handleEnterSearch(event)}
                      }}
                      onKeyPress={(event: any) => {this.handleEnterSearch(event) }}
                      placeholder='Search'
                    />
                    </Grid>
                </Grid>
                <Grid item>
                  <CR_Pagination />
                </Grid>
              </Grid>
              { showNoDataPanel ? (
            <Grid className="noData">
            <MyPATNoDataPanel
              imageURL="/assets/svg/userManagement/noRollData.svg"
              heading=
              {
                <>
                {
                  isSentRequestTab ?(
                    "No New Requests"
                  ):(
                    "No Pending Requests"
                  )
                }
                </>
              }
              htmlElement={
                <>
                 {
                   isSentRequestTab &&
                   <Button
                      variant="contained"
                      className={classes.btnCreateGoal}
                      color="primary"
                      onClick={this.handleTopNav.bind(this)}
                    >
                      Request Content
                    </Button>
                
                 } 
                    
                </>
              }
              subPara={
                <>
                {
              isSentRequestTab?(
              "You have not requested any Content. This list will be populated once you will create Content Requests."
              ):(
             "There are no Content creation requests, This list will be populated once you will receive Content Requests."
              )
              }
              </>
              }

              />
              </Grid>
          ) : (
            this.renderContentRequestCards()
              
          )}
            </>
          
        </Grid>
      </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  searchBar: state.contentRequestReducer.contentRequestReducer.searchBar,
  suggestions: state.contentRequestReducer.contentRequestReducer.suggestions,
  activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
  sentContentRequestsData: state.contentRequestReducer.contentRequestReducer.sentContentRequestsData,
  receivedContentRequestsData: state.contentRequestReducer.contentRequestReducer.receivedContentRequestsData
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
    setSentContentRequestsData:contentRequestActions.setSentContentRequestsData,
    setReceivedContentRequestsData:contentRequestActions.setReceivedContentRequestsData,
    setSearchBar:contentRequestActions.setSearchBar,
    getSentContentRequest:getSentContentRequest,
    getReceivedContentRequest:getReceivedContentRequest,
    setSearchText:setSearchText,
    deleteContentRequest:deleteContentRequest,
    setSuggestions: contentRequestActions.setSuggestions,
    resetFilters:contentRequestActions.resetFilters
	},
	dispatch
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(ListingContainer));
